import type { EditorViewModePluginOptions } from '@atlaskit/editor-plugin-editor-viewmode';

interface Props {
	options: EditorViewModePluginOptions;
}

export function editorViewModePluginOptions({ options }: Props): EditorViewModePluginOptions {
	return options;
}
